<template>
    <ValidationObserver
        ref="form"
        v-slot="{handleSubmit}"
    >
        <form @submit.prevent="handleSubmit(login)">
            <div class="p-8 login-tabs-container flex flex-col justify-center">
                <div>
                    <div class="form-container">
                        <div class="vx-card__title" v-if="isTitle">
                            <h4>{{ title }}</h4>
                        </div>
                        <div class="description-form" v-if="description">
                            {{description}}
                        </div>
                    </div>
                    <ValidationProvider
                        vid="email"
                        :name="t('global.Email')"
                        rules="required|email" v-slot="{ errors }"
                    >
                        <vs-input
                            name="email"
                            icon-no-border
                            :danger="!!errors.length"
                            :danger-text="errors[0]"
                            v-bind="$iconData('icon-user', 'fi-rr-user')"
                            :label-placeholder="t('global.Email')"
                            v-model.trim="form.email"
                            class="w-full"
                            ref="mail"
                            val-icon-danger="icon-alert-circle"
                            val-icon-pack="feather"
                        />
                    </ValidationProvider>

                    <ValidationProvider
                        vid="password"
                        :name="t('modals.Password')"
                        rules="required"
                        v-slot="{ errors }"
                    >
                        <vs-input
                            type="password"
                            name="password"
                            :danger="!!errors.length"
                            :danger-text="errors[0]"
                            icon-no-border
                            v-bind="$iconData('icon-lock', 'fi-rr-lock')"
                            :label-placeholder="t('modals.Password')"
                            v-model="form.password"
                            class="w-full mt-8"
                            val-icon-danger="icon-alert-circle"
                            val-icon-pack="feather"
                        />
                    </ValidationProvider>

                    <vs-button
                        class="float-right"
                        :disabled="loader"
                        button="submit"
                    >
                        {{ t('global.Login') }}
                    </vs-button>
                </div>
            </div>
        </form>
    </ValidationObserver>
</template>

<script>
import i18n from "@/i18n/i18n"
export default {
    props: {
        loader: {
            type: Boolean,
            default: false
        },

        isTitle: {
            type: Boolean,
            default: true
        },

        title: {
            type: String,
            required: true
        },

        description: {
            type: String
        }
    },

    data() {
        return {
            form: {
                email: '',
                password: ''
            }
        }
    },

    methods: {
        login() {
            this.$emit('submit', this.form)
        },

        t(text) {
            return i18n.t(text)
        }
    }
}
</script>

<style lang="scss" scoped>
.form-container {
    margin-bottom: 30px;

    .vx-card__title {
        margin-bottom: 8px;
        h4 {
            font-size: 26px;
            font-weight: bold;
        }
    }

    .description-form {
        color: #767676;
        font-size: 14px;
    }
}

.float-right {
    margin-top: 24px;
}
</style>
